import React, { useEffect, forwardRef } from 'react';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const SmoothScroll = forwardRef(({ children }, ref) => {
    useEffect(() => {
        const wrapper = ref.current;
        const content = wrapper.firstElementChild;

        const lenis = new Lenis({
            wrapper: wrapper,
            content: content,
            duration: 1.2,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            direction: 'vertical',
            gestureDirection: 'vertical',
            smooth: true,
            mouseMultiplier: 1,
            smoothTouch: false,
            touchMultiplier: 2,
        });

        // Integrate Lenis with GSAP ScrollTrigger
        lenis.on('scroll', ScrollTrigger.update);

        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);

        return () => {
            lenis.destroy();
            gsap.ticker.remove(lenis.raf);
        };
    }, [ref]);

    return (
        <div ref={ref} className="app-wrapper">
            <div className="app-content">
                {children}
            </div>
        </div>
    );
});

export default SmoothScroll;
